var React = require('react');

function Dollar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 0L7.0009 1.17102C8.11285 1.56444 8.92371 2.59487 8.99491 3.82373L9 4H7C7 3.44772 6.55228 3 6 3C5.44772 3 5 3.44772 5 4C5 4.51284 5.38604 4.93551 5.88338 4.99327L6 5C7.65685 5 9 6.34315 9 8C9 9.30588 8.16562 10.4169 7.0009 10.829L7 12H5L5.00009 10.8293C3.88764 10.4362 3.07632 9.4055 3.00509 8.17627L3 8H5C5 8.55229 5.44772 9 6 9C6.55228 9 7 8.55229 7 8C7 7.48716 6.61396 7.06449 6.11662 7.00673L6 7C4.34315 7 3 5.65685 3 4C3 2.69375 3.83485 1.58249 5.00009 1.17067L5 0H7Z","fill":"#424242"}));
}

Dollar.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Dollar;

Dollar.default = Dollar;
